import React from 'react';
import TextWithTooltip from '../../../../components/text-with-tooltip';
import { MIGRATE_TO_ENTERPRISE_TRUNK, REQUEST_CALL_BACK } from '../../../../app-constants';
import SSMRadioButton from '../ssm-radio-button/ssm-radio-button';
import FormSelectField from '../../../../components/form/select-field';
import { Desktop, Mobile } from '../../../../app-responsive';
import FormError from '../../../../components/form/error/error';

const SIPConnectMigrationTable = (props) => {
  const {
    siteId,
    siteServicesArray,
    sipConnectServiceDetails: {
      gdnText,
      primaryFNN,
      auxillary,
      migrateToSipConnectText,
      fnnHeadingText,
      actionHeadingText,
      confirmOrderText,
      typeHeadingText,
      typeTooltipText,
      migratetoAllEnterprise,
      migratetoAllSIP,
      currentServicesText,
      selectEnterpriseTrunking,
      migratetoEnterpriseText,
      migratetoEnterpriseErrorText,
    },
    enterpriseTrunking,
    enterpriseTrunkingNumbersOption,
    migrateToEnterpriseTrunk,
    migrateToEnterpriseTrunkSelection,
    handleMigrateToEnterpriseTrunk,
    handlEnterpriseTrunkSelection,
    enterpriseTrunkValidationTracking,
    formSubmitted,
  } = props;

  const getServiceTypeText = (type) => {
    switch (type) {
      case 'GDN':
        return gdnText;
      case 'PrimaryFNN' :
        return primaryFNN;
      default:
        return auxillary;
    }
  };

  const desktopMigrationTable = siteServicesArray.map(service => (
    <div key={service.number} className="row sip-connect-migrate-row">
      <div className={`col-3 ${service.type.toLowerCase()}`}> {getServiceTypeText(service.type)} </div>
      <div className="col-3">{service.number}</div>
      <div className="col-6">
        {enterpriseTrunking && migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`] && service.type !== 'Auxillary' &&
          <React.Fragment>
            <FormSelectField
              id={`${siteId}-${service.number}`}
              label=""
              options={enterpriseTrunkingNumbersOption}
              onBlur={handlEnterpriseTrunkSelection}
              value={(migrateToEnterpriseTrunkSelection[`${siteId}-${service.number}`] === 'REQUEST_CALL_BACK') ?
                REQUEST_CALL_BACK : migrateToEnterpriseTrunkSelection[`${siteId}-${service.number}`]}
              sendKeyValueOnChange
              placeholder={selectEnterpriseTrunking}
            />
            {(enterpriseTrunkValidationTracking && formSubmitted && !migrateToEnterpriseTrunkSelection[`${siteId}-${service.number}`]) &&
              <FormError errorText={migratetoEnterpriseErrorText} />
            }
          </React.Fragment>
        }
        {enterpriseTrunking && migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`] && service.type === 'Auxillary' &&
          <span>{migratetoEnterpriseText}</span>
        }
        {(!enterpriseTrunking || !migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`]) &&
          <span>{migrateToSipConnectText}</span>
        }
      </div>
    </div>
  ));

  const mobileMigrationTable = siteServicesArray.map(service => (
    <div key={service.number} className="row sip-connect-migrate-row">
      <div className={`col-12 ${service.type.toLowerCase()}`}> {getServiceTypeText(service.type)} </div>
      <div className="col-6 migrate-fnn-mobile-col"><strong>{fnnHeadingText}</strong></div>
      <div className="col-6 migrate-fnn-mobile-col">
        <strong>{actionHeadingText} </strong>
        {enterpriseTrunking &&
          <div className="selection-section">
            <SSMRadioButton
              radioButtonId={`${siteId}-migrateToSip`}
              radioButtonLabel={migratetoAllSIP}
              radioButtonChecked={!(migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`])}
              onRadioButtonCallBackActionWithToggle={handleMigrateToEnterpriseTrunk}
            />
            <SSMRadioButton
              radioButtonId={`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`}
              radioButtonLabel={migratetoAllEnterprise}
              radioButtonChecked={(migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`])}
              onRadioButtonCallBackActionWithToggle={handleMigrateToEnterpriseTrunk}
            />
          </div>
        }
      </div>
      <div className="col-6 migrate-fnn-mobile-col-data">{service.number}</div>
      <div className="col-6 migrate-fnn-mobile-col-data">
        {enterpriseTrunking && migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`] && service.type !== 'Auxillary' &&
          <React.Fragment>
            <FormSelectField
              id={`${siteId}-${service.number}`}
              label=""
              options={enterpriseTrunkingNumbersOption}
              onBlur={handlEnterpriseTrunkSelection}
              value={(migrateToEnterpriseTrunkSelection[`${siteId}-${service.number}`] === 'REQUEST_CALL_BACK') ?
                REQUEST_CALL_BACK : migrateToEnterpriseTrunkSelection[`${siteId}-${service.number}`]}
              sendKeyValueOnChange
              placeholder={selectEnterpriseTrunking}
            />
            {(enterpriseTrunkValidationTracking && formSubmitted && !migrateToEnterpriseTrunkSelection[`${siteId}-${service.number}`]) &&
              <FormError errorText={migratetoEnterpriseErrorText} />
            }
          </React.Fragment>
        }
        {enterpriseTrunking && migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`] && service.type === 'Auxillary' &&
          <span>{migratetoEnterpriseText}</span>
        }
        {(!enterpriseTrunking || !migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`]) &&
          <span>{migrateToSipConnectText}</span>
        }
      </div>
    </div>
  ));

  return (
    <div className="serviceTable">
      <div className="row headings hidden-mobile">
        <div className="col-6"><h2>{currentServicesText}</h2></div>
        <div className="col-6"><h2>{confirmOrderText}</h2></div>
      </div>
      <div className="row column-headings hidden-mobile">
        <div className="col-3">
          <TextWithTooltip
            labelText={typeHeadingText}
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="isdn-migration-table-type-tooltip"
            toolTipText={typeTooltipText}
          />

        </div>
        <div className="col-3">{fnnHeadingText}</div>
        <div className="col-6">
          {actionHeadingText}
          {enterpriseTrunking &&
            <div className="selection-section">
              <SSMRadioButton
                radioButtonId={`${siteId}-migrateToSip`}
                radioButtonLabel={migratetoAllSIP}
                radioButtonChecked={!(migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`])}
                onRadioButtonCallBackActionWithToggle={handleMigrateToEnterpriseTrunk}
              />
              <SSMRadioButton
                radioButtonId={`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`}
                radioButtonLabel={migratetoAllEnterprise}
                radioButtonChecked={(migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`])}
                onRadioButtonCallBackActionWithToggle={handleMigrateToEnterpriseTrunk}
              />
            </div>
          }
        </div>
      </div>
      <Desktop>
        {desktopMigrationTable}
      </Desktop>
      <Mobile>
        {mobileMigrationTable}
      </Mobile>
    </div>
  );
};

export default SIPConnectMigrationTable;
